/**
 * Created by mgoria on 6/23/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingLoginProviderException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when requested login provider is missing
 */
let MissingLoginProviderException = exports.MissingLoginProviderException = function (_Exception) {
  _inherits(MissingLoginProviderException, _Exception);

  /**
   * @param {String} providerName
   */
  function MissingLoginProviderException(providerName) {
    _classCallCheck(this, MissingLoginProviderException);

    return _possibleConstructorReturn(this, (MissingLoginProviderException.__proto__ || Object.getPrototypeOf(MissingLoginProviderException)).call(this, `Missing login provider "${providerName}" in deep-security.`));
  }

  return MissingLoginProviderException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/Exception/MissingLoginProviderException.js
// module id = 441
// module chunks = 0